import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

:host {
  --cat-carousel-slide-gap: var(--cat-carousel-spacing, var(--cat-space-medium));
  --cat-carousel-scroll-hint-start: 0px;
  --cat-carousel-scroll-hint-end: 0px;
  --cat-carousel-body-skeleton-height: calc(var(--size-base-unit) * 12);
  display: flex;
  height: 100%;
}

:host([behavior=overflow]) {
  --cat-carousel-scroll-hint-start: 10%;
  --cat-carousel-scroll-hint-end: 10%;
}

.cat-c-carousel {
  display: grid;
  grid-template-columns: var(--cat-carousel-grid-template-columns, 100%);
  grid-template-rows: var(--cat-carousel-grid-template-rows, auto);
  align-items: start;
  min-height: 100%;
  min-width: 100%;
  position: relative;
  container-type: inline-size;
}
.cat-c-carousel.cat-c-carousel--loading {
  --cat-carousel-spacing: var(--cat-space-3x-small);
}
.cat-c-carousel.cat-c-carousel--loading cat-button::part(base) {
  cursor: auto;
}
.cat-c-carousel .cat-c-carousel-body-skeleton {
  --cat-skeleton-loader-height: var(--cat-carousel-body-skeleton-height);
}
.cat-c-carousel-footer-loader {
  justify-content: center;
  display: flex;
  align-items: center;
  gap: var(--cat-space-x-small);
  padding-inline: var(--cat-space-3x-small);
  padding-block: var(--cat-space-3x-small);
}
.cat-c-carousel-controls-loader {
  display: flex;
  gap: var(--cat-space-3x-small);
}
.cat-c-carousel-autoplay-loader {
  display: flex;
  gap: var(--cat-space-3x-small);
}
.cat-c-carousel-divider-loader {
  margin-block-start: var(--cat-space-small);
}
.cat-c-carousel-arrows-loader {
  display: flex;
  gap: calc(var(--size-base-unit) * 0.125);
}
.cat-c-carousel-caption-skeleton {
  width: 100%;
}
.cat-c-carousel-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  height: 100%;
  min-height: 100%;
}
.cat-c-carousel-container {
  grid-auto-flow: column;
  grid-auto-columns: var(--cat-carousel-slide-size);
  grid-auto-rows: 100%;
  column-gap: var(--cat-carousel-slide-gap);
  scroll-snap-type: x mandatory;
  scroll-padding-inline: var(--cat-carousel-scroll-hint-start) var(--cat-carousel-scroll-hint-end);
  padding-inline: var(--cat-carousel-scroll-hint-start) var(--cat-carousel-scroll-hint-end);
  overflow: auto hidden;
  display: grid;
  height: 100%;
  width: 100%;
  place-items: center center;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  aspect-ratio: calc(var(--cat-carousel-aspect-ratio) * var(--cat-carousel-slides-per-page));
  --cat-carousel-slide-size: calc(
    (100% - (var(--cat-carousel-slides-per-page) - 1) * var(--cat-carousel-slide-gap)) / var(--cat-carousel-slides-per-page)
  );
}
.cat-c-carousel-container::-webkit-scrollbar {
  display: none;
}
.cat-c-carousel-prev-button, .cat-c-carousel-next-button {
  position: absolute;
  inset-block: calc(var(--size-base-unit) * 1.25);
  border-radius: calc(var(--size-base-unit) * 0.5);
  --cat-button--icon-only-ghost-default: rgb(255 255 255 / 20%);
  --cat-button-ghost-hover-background: rgb(255 255 255 / 50%);
  --cat-button--icon-only-ghost-focus: rgb(255 255 255 / 50%);
  --cat-button--icon-only-ghost-active: rgb(255 255 255 / 70%);
  --cat-button-padding: var(--cat-space-medium) var(--cat-space-x-small);
}
.cat-c-carousel--navigation-dark .cat-c-carousel-prev-button, .cat-c-carousel--navigation-dark .cat-c-carousel-next-button {
  --cat-button-icon-only-inverted-default: rgb(2 2 2 / 20%);
  --cat-button-icon-only-inverted-hover: rgb(0 0 0 / 50%);
  --cat-button-icon-only-inverted-focus: rgb(0 0 0 / 50%);
  --cat-button-icon-only-inverted-active: rgb(0 0 0 / 70%);
}
.cat-c-carousel-prev-button {
  inset-inline-start: calc(var(--size-base-unit) * 1.25);
}
.cat-c-carousel-next-button {
  inset-inline-end: calc(var(--size-base-unit) * 1.25);
}
.cat-c-carousel-navigation-external.cat-c-carousel-autoplay .cat-c-carousel--slide-count {
  margin-inline-end: calc(var(--size-base-unit) * 16.125);
}
.cat-c-carousel-footer, .cat-c-carousel--slide-count {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  --cat-theme-color-button-content: var(--cat-theme-color-content-default);
  grid-row: 2/auto;
  grid-column: 1/auto;
  display: flex;
  gap: var(--cat-space-x-small);
  align-items: flex-start;
  padding-inline: var(--cat-space-3x-small);
}
.cat-c-carousel-footer .cat-c-carousel-slideNumber,
.cat-c-carousel-footer .cat-c-carousel-caption, .cat-c-carousel--slide-count .cat-c-carousel-slideNumber,
.cat-c-carousel--slide-count .cat-c-carousel-caption {
  padding-block-start: var(--cat-space-x-small);
}
.cat-c-carousel-navigation-external .cat-c-carousel-footer, .cat-c-carousel-navigation-external .cat-c-carousel--slide-count {
  margin-inline-end: calc(var(--size-base-unit) * 11.125);
  padding-inline-end: 0;
}
.cat-c-carousel-slideNumber {
  display: flex;
}
.cat-c-carousel-caption {
  overflow: hidden;
  word-wrap: break-word;
}
.cat-c-carousel-controls {
  display: flex;
  gap: var(--cat-space-3x-small);
  margin-inline-start: auto;
}
.cat-c-carousel-navigation-external-buttons {
  --cat-theme-color-button-content: var(--cat-theme-color-content-default);
  display: inline-flex;
  gap: 1px;
  margin-inline-start: auto;
  padding-inline: 4px;
  grid-row: 2/auto;
  grid-column: 1/auto;
  align-self: flex-start;
}
.cat-c-carousel-progress-container {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding-inline: var(--cat-space-x-small);
  border-radius: calc(var(--size-base-unit) * 0.5);
  background: rgba(255, 255, 255, 0.5);
  grid-row: 2/auto;
  grid-column: 1/auto;
  margin-inline: auto;
  padding-block-start: var(--cat-space-x-small);
  /*
   * If
   * 1) Carousel is in mobile view,
   * 2) Carousel container width is less than or equal to 400px, 
   * then place image dots to the left.
   */
}
.cat-c-carousel:is(.cat-c-carousel--is-mobile) .cat-c-carousel-progress-container {
  margin-inline: 0 auto;
  padding-inline-start: var(--cat-space-3x-small);
}
@container (max-width: 400px) {
  .cat-c-carousel-progress-container {
    margin-inline: 0 auto;
    padding-inline-start: var(--cat-space-3x-small);
  }
}
.cat-c-carousel--navigation-dark .cat-c-carousel-progress-container {
  background: rgba(0, 0, 0, 0.5);
}
`;
       